import { render, staticRenderFns } from "./NewCheckbox.vue?vue&type=template&id=52c143f2&"
import script from "./NewCheckbox.vue?vue&type=script&lang=js&"
export * from "./NewCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./NewCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports